import { render, staticRenderFns } from "./User_add.vue?vue&type=template&id=34d749f1&scoped=true"
import script from "./User_add.vue?vue&type=script&lang=js"
export * from "./User_add.vue?vue&type=script&lang=js"
import style0 from "./User_add.vue?vue&type=style&index=0&id=34d749f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d749f1",
  null
  
)

export default component.exports